import { getRequestConfig, withMakeRequest } from '~/api';
import Request from '~/api/Request.ts';
import {
  FeatureFlagKeys,
  FeatureSettings,
  ListEnvironmentFeaturesResponse,
  ToggleEnvironmentFeatureRequest
} from '~/api/types/featureFlagData.ts';

const getEnvironmentFeatures: () => Promise<FeatureSettings[]> =
  withMakeRequest(
    async () =>
      await Request.getInstance().get(
        `/features`,
        getRequestConfig({ addEnvDomain: true })
      ),
    (data: ListEnvironmentFeaturesResponse) => data.features
  );

const toggleEnvironmentFeature: (
  request: ToggleEnvironmentFeatureRequest
) => Promise<Partial<Record<FeatureFlagKeys, boolean>>> = withMakeRequest(
  async ({ environmentId, feature, status }: ToggleEnvironmentFeatureRequest) =>
    await Request.getInstance().post(
      `/environments/${environmentId}/features/${feature}:${status}`,
      {},
      getRequestConfig({ addEnvDomain: true })
    )
);

const enableFSAForEnvironment: (environmentId: string) => Promise<any> =
  withMakeRequest(
    async (environmentId) =>
      await Request.getInstance().post(
        `/environments/${environmentId}/features/fsa/enable`,
        {},
        getRequestConfig({ addEnvDomain: true })
      )
  );

const disableFSAForEnvironment: () => Promise<any> = withMakeRequest(
  async () =>
    await Request.getInstance().post(
      `/features/fsa/disable`,
      {},
      getRequestConfig({ addEnvDomain: true })
    )
);

export {
  getEnvironmentFeatures,
  toggleEnvironmentFeature,
  enableFSAForEnvironment,
  disableFSAForEnvironment
};
